// @flow
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { CircularProgress } from 'material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import { backendUrl } from '../../lib/config';
import { FileUploader } from '../ui/file-uploader/file-uploader';

interface SystemSettingsProps {}

interface SystemSettingsState {
	isLoaded: boolean;
}

class SystemSettings extends React.Component<SystemSettingsProps, SystemSettingsState> {
	state = {
		isLoading: false,
		isFileExist: false,
	};

	componentDidMount = async () => {
		const response = await fetch(`${backendUrl}/ads`);
		const status = response.status;
		if (status === 200) {
			this.setState({
				isFileExist: true,
			});
		}
	};

	onUploadAdsFile = async event => {
		const file = event.target.files[0];
		const formData = new FormData();
		formData.append('file', file);
		this.setState({
			isLoading: true,
		});
		await fetch(`${backendUrl}/upload_ads`, {
			method: 'POST',
			body: formData,
		});
		this.setState({
			isLoading: false,
		});
	};

	render() {
		const { isLoading, isFileExist } = this.state;
		return (
			<section className="topics column-wrapper">
				<Paper className="column--1-1">
					<header className="column--header">
						<h3 className="column--title-regular">Системный раздел</h3>
					</header>
					<FileUploader label="ЗАГРУЗИТЬ ADS ФАЙЛ" filename={'ads'} />
					<FileUploader label="ЗАГРУЗИТЬ список иноагентов ФАЙЛ" filename={'inoagents'} />
				</Paper>
			</section>
		);
	}
}
export default withRouter(SystemSettings);



// WEBPACK FOOTER //
// src/components/system-settings/SystemSettings.js